module.exports = __webpack_public_path__ + "img/gg_profile.a0adc650.svg";